import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export function applyAuthHeadersFromCookieToAxios(axiosInstance) {
  if (!axiosInstance?.defaults?.headers?.common || !Auth.hasAuthCookie()) {
    return;
  }
  const data = Auth.getAuthData();
  if (!data) return;
  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = data;
  Object.assign(axiosInstance.defaults.headers.common, {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  });
}

export default axios => {
  const { apiHost = '' } = window.clinicdeskConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  applyAuthHeadersFromCookieToAxios(wootApi);
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
